import { BoxGeometry, Mesh, MeshStandardMaterial } from "three";

import type { Side, Square, StructureName } from "src/api";

import type { PickableWorldObject } from "../../../../render/world/PickableWorldObject";
import { WorldObject } from "../../../../render/world/WorldObject";
import { easeOutCubic } from "../../../../render/animation/easingFunctions";
import { Tween } from "../../../../render/animation/Tween";
import { disposeObject } from "../../../../render/utilities/disposeObject";
import { squareToWorld } from "../../utilities/boardCoordinates";
import { STRUCTURE_DEFINITIONS } from "./structureDefinitions";

export class Structure extends WorldObject implements PickableWorldObject {
  // TODO: spinning animation is temporary and is a test
  private tempSpinTween: Tween | null = null;
  private tempSpinStartYaw = 0;
  private tempSpinDirection: 1 | -1 = 1;

  constructor(
    readonly kind: StructureName,
    readonly owner: Side,
    square: Square
  ) {
    super();

    const { placeholderColor, placeholderHeight } = STRUCTURE_DEFINITIONS[kind];
    const mesh = new Mesh(
      new BoxGeometry(0.7, placeholderHeight, 0.7),
      new MeshStandardMaterial({ color: placeholderColor })
    );
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    this.root.add(mesh);
    this.root.position.copy(squareToWorld(square).setY(placeholderHeight / 2));
  }

  onPicked() {
    this.setOutline(true);
    this.startSpin(1);
  }

  onUnpicked() {
    this.setOutline(false);
    this.startSpin(-1);
  }

  step(deltaSeconds: number) {
    if (this.tempSpinTween === null) return;

    this.tempSpinTween.step(deltaSeconds);
    this.root.rotation.y = this.tempSpinStartYaw + this.tempSpinDirection * 2 * Math.PI * this.tempSpinTween.progress;
    if (this.tempSpinTween.isFinished) this.tempSpinTween = null;
  }

  dispose() {
    disposeObject(this.root);
  }

  private startSpin(direction: 1 | -1) {
    this.tempSpinStartYaw = this.root.rotation.y;
    this.tempSpinDirection = direction;
    this.tempSpinTween = new Tween(0.7, easeOutCubic);
  }
}
